module.exports = __webpack_public_path__ + "img/preview.70a99428.webp";